
import React from 'react';
import apiFetch from '@wordpress/api-fetch';
import {instanceOf} from 'prop-types';
import {withCookies, Cookies} from 'react-cookie';
import {Navigation, Pagination, Autoplay, EffectFade, EffectCube, EffectFlip, FreeMode} from 'swiper/modules';
import {Swiper, SwiperSlide, useSwiper} from 'swiper/react';
import {InView} from 'react-intersection-observer';
import {TransformWrapper, TransformComponent} from 'react-zoom-pan-pinch';
import {css, keyframes} from '@emotion/css';
import * as lodash from 'lodash';
import * as dateFns from 'date-fns';
import ja from 'date-fns/locale/ja';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSquarePlus, faClock, faHandPointer, faCubesStacked, faShrimp, faCircleXmark, faHeart, faCalendarDays, faCalculator, faList} from '@fortawesome/free-solid-svg-icons';
import {faWindowRestore} from '@fortawesome/free-regular-svg-icons';
import {Link} from 'react-router-dom';


import {getTimeSectionAndMenuKind} from '../helper';
import Loading from './loading';

class FrontPage extends React.Component {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired,
    }

    constructor(props) {
        super(props);

        const {cookies} = props;
        let new_uuid = '';
        try {
            new_uuid = crypto.randomUUID();
        } catch (e) {
            new_uuid = this.getRandomString(32);
        }
        const uuid = cookies.get('uuid') || new_uuid;
        this.state = {
            cafeteria_base: {
                cafeteria_name: '',
                cafeteria_logo: '',
                cafeteria_tax: 'in_tax_price',
                cafeteria_open_saturday: true,
                cafeteria_open_sunday: true,
                cafeteria_time_section_1_from: '',
                cafeteria_time_section_1_to: '',
                cafeteria_time_section_2_from: '',
                cafeteria_time_section_2_to: '',
                cafeteria_time_section_3_from: '',
                cafeteria_time_section_3_to: '',
                cafeteria_time_section_4_from: '',
                cafeteria_time_section_4_to: '',
                cafeteria_time_section_1_smt_from: '',
                cafeteria_time_section_1_smt_to: '',
                cafeteria_time_section_2_smt_from: '',
                cafeteria_time_section_2_smt_to: '',
                cafeteria_time_section_3_smt_from: '',
                cafeteria_time_section_3_smt_to: '',
                cafeteria_time_section_4_smt_from: '',
                cafeteria_time_section_4_smt_to: '',
                cafeteria_board_quantity: 1,
                cafeteria_event_quantity: 1,
                cafeteria_corner_quantity: 1,    
            },
            cafeteria_corner: [],
            is_initialize: false,
            uuid: uuid,
            cafeteria_menu: [],
            cafeteria_menu_page: 1,
            cafeteria_menu_max_page: 1,
            event_news: [],
            site_link: [],
            is_todays_or_weeks: true,
            is_todays_or_weeks_or_news: 1,
            is_menu_loading: true,
            is_event_loading: true,
            is_link_loading: true,
            provide_date: '',
            time_section: '',
            event_time_section: '',
            selected_acf: null,
            selected_img_url: '',
            selected_event_img_url: '',
            is_open_menu_detail: false,
            is_open_event_image: false,
            is_open_navi_menu: false,
        }
    }

    // randomUUIDが使えない場合の代替
    getRandomString = (len) => {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopwqstuvwxyz0123456789';
        const randomValues = new Uint32Array(len);
        crypto.getRandomValues(randomValues);
        const result = Array.from(randomValues, (v) => chars[v % chars.length]).join('');
        return result;
    }

    // 基本設定の取得 + 初期表示食堂メニューを取得
    fetchSetting = async () => {
        // スマホサイトのみ、ページ表示の初回だけしか取得しないため、function.phpでwindowオブジェクト配下にプリロードする形に変更し高速化
        // const res = await apiFetch({
        //     path: '/wp-json/cafeteria_api/signage_setting'
        // });

        // 基本設定の取得及び設定
        let provide_date = dateFns.format(new Date(), 'yyyyMMdd');
        let time_section = '1';
        if (window.cafeteria_settings.cafeteria_info_base_setting) {
            const res_time_section = getTimeSectionAndMenuKind(
                window.cafeteria_settings.cafeteria_info_base_setting.cafeteria_time_section_1_from,
                window.cafeteria_settings.cafeteria_info_base_setting.cafeteria_time_section_1_to,
                window.cafeteria_settings.cafeteria_info_base_setting.cafeteria_time_section_2_from,
                window.cafeteria_settings.cafeteria_info_base_setting.cafeteria_time_section_2_to,
                window.cafeteria_settings.cafeteria_info_base_setting.cafeteria_time_section_3_from,
                window.cafeteria_settings.cafeteria_info_base_setting.cafeteria_time_section_3_to,
                window.cafeteria_settings.cafeteria_info_base_setting.cafeteria_time_section_4_from,
                window.cafeteria_settings.cafeteria_info_base_setting.cafeteria_time_section_4_to,
            );
            provide_date = res_time_section.provide_date;
            time_section = res_time_section.time_section;
            this.setState({
                cafeteria_base: window.cafeteria_settings.cafeteria_info_base_setting,
            });
        }
        if (window.cafeteria_settings.cafeteria_info_signage_setting && window.cafeteria_settings.cafeteria_info_signage_setting.cafeteria_corner) {
            this.setState({
                cafeteria_corner: window.cafeteria_settings.cafeteria_info_signage_setting.cafeteria_corner,
            });
        }

        this.fetchEvent(provide_date, time_section, 1);
        const menu = await this.fetchMenu(provide_date, time_section, 1, false);
        if (menu.menu.length > 0) {
            this.setState({
                cafeteria_menu: menu.menu,
                cafeteria_menu_page: 1,
                cafeteria_menu_max_page: menu.max_page,
                is_menu_loading: false,
                provide_date: provide_date,
                time_section: time_section,
                event_time_section: time_section,
            });
        } else {
            this.setState({
                is_menu_loading: false,
                provide_date: provide_date,
                time_section: '',
                event_time_section: time_section,
            });
        }
    }

    // 食堂メニューの取得
    fetchMenu = async (provide_date, time_section, page = 1, set_state = true) => {
        const time_sections = ['1', '2', '3', '4'].filter((val) => {
            return Number(val) >= Number(time_section);
        });
        const cafeteria_menu_path = '/wp-json/wp/v2/cafeteria_menu?per_page=10&page=' + page + '&provide_date=' + provide_date + '&time_section=' + time_sections.join();
        const menu = await apiFetch({
            path: cafeteria_menu_path,
            parse: false,
        });
        const menu_data = await menu.json();
        const max_page = Number(menu.headers.get('x-wp-totalpages'));
        const {cookies} = this.props;
        const after_menu = menu_data.map((val) => {
            if (val.acf.mcd) {
                const like = cookies.get(val.acf.mcd);
                if (like !== undefined && like !== null && like == '1') {
                    val.like = true;
                } else {
                    val.like = false;
                }
            } else {
                val.like = false;
            }
            return val;
        });
        if (set_state) {
            this.setState({
                cafeteria_menu: after_menu,
                cafeteria_menu_page: 1,
                cafeteria_menu_max_page: max_page,
                is_menu_loading: false,
                provide_date: provide_date,
                time_section: time_section,
            });
        }
        return {
            menu: after_menu,
            max_page: max_page,
        };
    }

    // イベント／お知らせの取得
    fetchEvent = async (provide_date, time_section, is_todays_or_weeks_or_news) => {
        let add_param = '';
        switch (is_todays_or_weeks_or_news) {
            case 1:
                add_param = '&provide_date=' + provide_date + '&event_or_news=1&time_section=0,' + time_section;
                break;
            case 2:
                add_param = '&provide_date=' + provide_date + '&before_provide=1&event_or_news=1';
                break;
            case 3:
                add_param = '&provide_date=' + provide_date + '&event_or_news=2&time_section=0,' + time_section;
        }
        const event_news_path = '/wp-json/wp/v2/event_news?per_page=100&acf_format=standard&smartphone_view=1' + add_param;
        const event_news = await apiFetch({
            path: event_news_path
        });
        this.setState({
            event_news: event_news,
            is_event_loading: false,
        });
    }

    // リンクの取得
    fetchLink = async () => {
        const site_link_path = '/wp-json/wp/v2/site_link?per_page=100&acf_format=standard';
        const site_link = await apiFetch({
            path: site_link_path,
        });
        this.setState({
            site_link: site_link,
            is_link_loading: false,
        });
    }

    // ナビメニューの表示非表示
    onClickNaviMenu = () => {
        this.setState((prev_state) => {
            const navi_bool = !prev_state.is_open_navi_menu;
            return {
                is_open_navi_menu: navi_bool,
            }
        });
    }

    // ナビメニューボタン押下によるスクロール
    onClickNaviMenuButton = (target_id, change_menu_tab = null) => {
        // 対象位置へ移動
        const target = document.getElementById(target_id);
        if (target) {
            const rect = target.getBoundingClientRect();
            const target_top = rect.top + window.scrollY - 48;
            window.scrollTo({
                top: target_top,
                behavior: 'smooth',
            });
        }
        // ナビメニューをクローズ
        this.setState({
            is_open_navi_menu: false,
        });
        // メニュータブの切替を発生させる場合
        if (change_menu_tab !== null && this.state.is_todays_or_weeks !== change_menu_tab) {
            this.changeMenuTab(change_menu_tab);
        }
    }

    // メニュータブの切替
    changeMenuTab = async (is_todays_or_weeks) => {
        // ステータスを切替、メニューを初期化
        this.setState({
            is_todays_or_weeks: is_todays_or_weeks,
            cafeteria_menu: [],
            is_menu_loading: is_todays_or_weeks,
            provide_date: '',
            time_section: '',
        });
        // 本日のメニューの場合、すぐにメニューを取得する
        if (is_todays_or_weeks) {
            const res_time_section = getTimeSectionAndMenuKind(
                this.state.cafeteria_base.cafeteria_time_section_1_from,
                this.state.cafeteria_base.cafeteria_time_section_1_to,
                this.state.cafeteria_base.cafeteria_time_section_2_from,
                this.state.cafeteria_base.cafeteria_time_section_2_to,
                this.state.cafeteria_base.cafeteria_time_section_3_from,
                this.state.cafeteria_base.cafeteria_time_section_3_to,
                this.state.cafeteria_base.cafeteria_time_section_4_from,
                this.state.cafeteria_base.cafeteria_time_section_4_to,
            );
            const menu = await this.fetchMenu(res_time_section.provide_date, res_time_section.time_section, 1, false);
            if (menu.menu.length > 0) {
                this.setState({
                    cafeteria_menu: menu.menu,
                    cafeteria_menu_page: 1,
                    cafeteria_menu_max_page: menu.max_page,
                    is_menu_loading: false,
                    provide_date: res_time_section.provide_date,
                    time_section: res_time_section.time_section,
                });
            } else {
                this.setState({
                    cafeteria_menu: [],
                    cafeteria_menu_page: 1,
                    cafeteria_menu_max_page: 1,
                    is_menu_loading: false,
                    provide_date: res_time_section.provide_date,
                    time_section: '',
                });
            }
        }
    }

    // イベントタブの切り替え
    changeEventTab = async (is_todays_or_weeks_or_news) => {
        // ステータスを切替、イベントを初期化
        this.setState({
            is_todays_or_weeks_or_news: is_todays_or_weeks_or_news,
            event_news: [],
            is_event_loading: true,
        });
        // イベント／お知らせを取得
        await this.fetchEvent(
            this.state.provide_date,
            this.state.event_time_section,
            is_todays_or_weeks_or_news
        );
    }

    // 日付ボタン押下時の処理
    onClickDateButton = async (provide_date) => {
        this.setState({
            cafeteria_menu: [],
            is_menu_loading: true,
            provide_date: provide_date,
        });
        const res = await this.fetchMenu(provide_date, '1', 1, false);
        if (res.menu.length > 0) {
            this.setState({
                cafeteria_menu: res.menu,
                cafeteria_menu_page: 1,
                cafeteria_menu_max_page: res.max_page,
                is_menu_loading: false,
                time_section: '1',
            });
        } else {
            this.setState({
                cafeteria_menu_page: 1,
                cafeteria_menu_max_page: 1,
                is_menu_loading: false,
                time_section: '9',
            });
        }
    }

    // 追加読み込みボタン押下時の処理
    onClickAddLoadingButton = async () => {
        this.setState({
            is_menu_loading: true,
        });
        const page = this.state.cafeteria_menu_page + 1;
        const res = await this.fetchMenu(this.state.provide_date, this.state.time_section, page, false);
        if (res.menu.length > 0) {
            const marge_menu = this.state.cafeteria_menu.concat(res.menu);
            const state_data = {
                cafeteria_menu: marge_menu,
                cafeteria_menu_page: page,
                cafeteria_menu_max_page: res.max_page,
                is_menu_loading: false,
            };
            if (page >= res.max_page) {
                state_data.time_section = '9';
            }
            this.setState(state_data);
        } else {
            this.setState({
                cafeteria_menu_page: page,
                cafeteria_menu_max_page: res.max_page,
                is_menu_loading: false,
                time_section: '9',
            });
        }
    }

    // textの改行コードを<br/>変換したDOMを返す
    convertMultiLines = (before_text) => {
        const lines = before_text.split(/\r?\n/);
        const result = [];
        const len = lines.length;
        for (let i = 0; i < len; i++) {
            result.push(
                <React.Fragment>
                    {lines[i]}
                    {
                        (i < len - 1) &&
                        <br/>
                    }
                </React.Fragment>
            );
        }
        return result;
    }

    // いいねをした際、サーバーへ送信する。Cookieはサーバーサイドで作成し、レスポンスで返す（safari等の有効期限対策）
    setLikeButtonStatus = (mcd) => {
        // DBにいいね回数を加算する ※非同期
        const headers = new Headers();
        headers.append('X-WP-Nonce', window.cafeteria_csrf.nonce);
        const res = apiFetch({
            path: '/wp-json/cafeteria_api/like_post',
            method: 'POST',
            headers: headers,
            data: {
                mcd: mcd,
                count: true,
            }
        });
        // メニューのいいね状態を更新
        const update_menu = this.state.cafeteria_menu.map((val) => {
            if (val.acf.mcd === mcd) {
                val.like = true;
            }
            return val;
        });
        this.setState({
            cafeteria_menu: update_menu,
        });
    }

    // いいねを解除した際、サーバーへ送信する。Cookieはいいね登録時と同様
    removeLikeButtonStatus = (mcd) => {
        // DBにいいね回数を減算する ※非同期
        const headers = new Headers();
        headers.append('X-WP-Nonce', window.cafeteria_csrf.nonce);
        const res = apiFetch({
            path: '/wp-json/cafeteria_api/like_post',
            method: 'POST',
            headers: headers,
            data: {
                mcd: mcd,
                count: false,
            }
        });
        // メニューのいいね状態を更新
        const update_menu = this.state.cafeteria_menu.map((val) => {
            if (val.acf.mcd === mcd) {
                val.like = false;
            }
            return val;
        });
        this.setState({
            cafeteria_menu: update_menu,
        });
    }

    // いいねボタン押下処理
    handleLikeButton = (mcd, like) => {
        if (like) {
            this.removeLikeButtonStatus(mcd);
        } else {
            this.setLikeButtonStatus(mcd);
        }
    }

    // 動的css
    cssCornerLabel = (provide_date, time_section, corner_number) => {
        const week_num = dateFns.getDay(dateFns.parse(provide_date, 'yyyyMMdd', new Date()));
        const time_num = Number(time_section) - 1;
        const corner_num = corner_number - 1;
        let text_color = '#ffffff';
        let bg_color = '#000000';
        if (this.state.cafeteria_corner[week_num][time_num][corner_num]) {
            text_color = this.state.cafeteria_corner[week_num][time_num][corner_num].text_color;
            bg_color = this.state.cafeteria_corner[week_num][time_num][corner_num].bg_color;
        }
        return css({
            color: text_color,
            backgroundColor: bg_color,
        });
    }

    async componentDidMount() {
        // 初期処理
        this.fetchSetting();
        this.fetchLink();
    }

    render() {
        // メニュー一覧を作成
        const menu = [];
        if (this.state.cafeteria_menu.length > 0) {
            let time_section_header = '0';
            let header_date = '';
            let calc_visible = false;
            if (!this.state.is_todays_or_weeks) {
                const pdate = dateFns.parse(this.state.provide_date, 'yyyyMMdd', new Date());
                const now = Number(dateFns.format(new Date(), 'yyyyMMdd'));
                const target = Number(dateFns.format(pdate, 'yyyyMMdd'));
                header_date = dateFns.format(pdate, 'M/d(E) ', {locale: ja});
                if (now <= target) {
                    calc_visible = true;
                }
            } else {
                calc_visible = true;
            }
            for (const m of this.state.cafeteria_menu) {
                const price = m.acf[this.state.cafeteria_base.cafeteria_tax];
                if (time_section_header !== m.acf.time_section) {
                    time_section_header = m.acf.time_section;
                    const from_text = this.state.cafeteria_base[`cafeteria_time_section_${time_section_header}_smt_from`].substr(0, 1) === '0' ?
                        this.state.cafeteria_base[`cafeteria_time_section_${time_section_header}_smt_from`].substr(1) :
                        this.state.cafeteria_base[`cafeteria_time_section_${time_section_header}_smt_from`];
                    const to_text = this.state.cafeteria_base[`cafeteria_time_section_${time_section_header}_smt_to`].substr(0, 1) === '0' ?
                        this.state.cafeteria_base[`cafeteria_time_section_${time_section_header}_smt_to`].substr(1) :
                        this.state.cafeteria_base[`cafeteria_time_section_${time_section_header}_smt_to`];
                    const is_next_day = Number(to_text.replaceAll(':', '')) <= Number(from_text.replaceAll(':', ''));
                    menu.push(
                        <InView
                            className="transition-1s shadow-xy-0 opacity-0"
                            as="h1"
                            triggerOnce={true}
                            onChange={(inView, entry) => {if(inView) {entry.target.className = "transition-1s shadow-xy-5 opacity-1"}}}
                        >
                            <FontAwesomeIcon icon={faClock} />&nbsp;{`${header_date}${from_text} ～ ${is_next_day ? '翌' : ''}${to_text}`}
                            {
                                calc_visible &&
                                <Link to={`/nutrition-calc/?provide_date=${this.state.provide_date}&time_section=${time_section_header}`} className="calc-small-button">
                                    <FontAwesomeIcon icon={faCalculator} />&nbsp;栄養計算
                                </Link>
                            }
                        </InView>
                    );
                }
                menu.push(
                    <InView
                        className="menu-content transition-1s shadow-xy-0 move-y-50 opacity-0"
                        as="div"
                        rootMargin="-50px"
                        triggerOnce={true}
                        onChange={(inView, entry) => {if(inView) {entry.target.className = "menu-content transition-1s shadow-xy-5 move-y-0 opacity-1"}}}
                    >
                        {
                            m.acf.menu_kind === '1' &&
                            <div className="menu-img">
                                <img
                                    className="menu-img-main"
                                    src={m.img_urls.large}
                                    onError={(e) => {e.target.src = window.cafeteria_path.template_url + '/img/no_image.svg'}}
                                />
                                {
                                    this.state.is_todays_or_weeks &&
                                    <React.Fragment>
                                        {
                                            m.acf.stamp_group_3 === '1' &&
                                            <div className="menu-img-alternative">
                                                <img
                                                    className="menu-img-alternative-img"
                                                    src={window.cafeteria_path.template_url + '/img/alternative.svg'}
                                                />
                                            </div>
                                        }
                                        {
                                            m.acf.stamp_group_1 === '1' &&
                                            <img
                                                className="menu-img-stamp-left-top menu-img-stamp-rotate"
                                                src={window.cafeteria_path.template_url + '/img/new.svg'}
                                            />
                                        }
                                        {
                                            m.acf.stamp_group_1 === '2' &&
                                            <img
                                                className="menu-img-stamp-left-top menu-img-stamp-rotate"
                                                src={window.cafeteria_path.template_url + '/img/event.svg'}
                                            />
                                        }
                                        {
                                            m.acf.stamp_group_1 === '3' &&
                                            <img
                                                className="menu-img-stamp-left-top menu-img-stamp-rotate"
                                                src={window.cafeteria_path.template_url + '/img/pick_up.svg'}
                                            />
                                        }
                                        {
                                            m.acf.stamp_group_1 === '4' &&
                                            <img
                                                className="menu-img-stamp-left-top menu-img-stamp-breathing"
                                                src={window.cafeteria_path.template_url + '/img/vegetable.svg'}
                                            />
                                        }
                                        {
                                            m.acf.stamp_group_1 === '5' &&
                                            <img
                                                className="menu-img-stamp-left-top menu-img-stamp-breathing"
                                                src={window.cafeteria_path.template_url + '/img/low_sodium.svg'}
                                            />
                                        }
                                        {
                                            m.acf.stamp_group_1 === '6' &&
                                            <img
                                                className="menu-img-stamp-left-top menu-img-stamp-breathing"
                                                src={window.cafeteria_path.template_url + '/img/calorie.svg'}
                                            />
                                        }
                                        {
                                            m.acf.stamp_group_1 === '7' &&
                                            <img
                                                className="menu-img-stamp-left-top menu-img-stamp-breathing"
                                                src={window.cafeteria_path.template_url + '/img/carbs_off.svg'}
                                            />
                                        }
                                        {
                                            m.acf.stamp_group_4 === '1' &&
                                            <img
                                                className="menu-img-stamp-right-top menu-img-stamp-scale"
                                                src={window.cafeteria_path.template_url + '/img/half_size.svg'}
                                            />
                                        }
                                        {
                                            m.acf.stamp_group_4 === '2' &&
                                            <img
                                                className="menu-img-stamp-right-top menu-img-stamp-scale"
                                                src={window.cafeteria_path.template_url + '/img/mini_size.svg'}
                                            />
                                        }
                                        {
                                            m.acf.stamp_group_5 === 'a1' &&
                                            <img
                                                className="menu-img-stamp-left-bottom menu-img-stamp-scale"
                                                src={window.cafeteria_path.template_url + '/img/garlic.svg'}
                                            />
                                        }
                                        {
                                            /^b/.test(m.acf.stamp_group_5) &&
                                            <img
                                                className="menu-img-stamp-left-bottom menu-img-stamp-scale"
                                                src={window.cafeteria_path.template_url + '/img/hot_' + m.acf.stamp_group_5.substr(1) + '.svg'}
                                            />
                                        }
                                        {
                                            /^c/.test(m.acf.stamp_group_5) &&
                                            <img
                                                className="menu-img-stamp-left-bottom menu-img-stamp-vibration"
                                                src={window.cafeteria_path.template_url + '/img/wait_' + m.acf.stamp_group_5.substr(1) + '.svg'}
                                            />
                                        }
                                        {
                                            /^d/.test(m.acf.stamp_group_5) &&
                                            <img
                                                className="menu-img-stamp-left-bottom menu-img-stamp-scale"
                                                src={window.cafeteria_path.template_url + '/img/last_' + m.acf.stamp_group_5.substr(1) + '.svg'}
                                            />
                                        }
                                        {
                                            m.acf.stamp_group_2 === '1' &&
                                            <img
                                                className="menu-img-stamp-right-bottom menu-img-stamp-scale"
                                                src={window.cafeteria_path.template_url + '/img/just_a_minute_please.svg'}
                                            />
                                        }
                                        {
                                            m.acf.stamp_group_2 === '2' &&
                                            <img
                                                className="menu-img-stamp-right-bottom menu-img-stamp-scale"
                                                src={window.cafeteria_path.template_url + '/img/sold_out_soon.svg'}
                                            />
                                        }
                                        {
                                            m.acf.stamp_group_2 === '4' &&
                                            <img
                                                className="menu-img-stamp-right-bottom menu-img-stamp-scale"
                                                src={window.cafeteria_path.template_url + '/img/1f_sales.svg'}
                                            />
                                        }
                                        {
                                            m.acf.stamp_group_2 === '5' &&
                                            <img
                                                className="menu-img-stamp-right-bottom menu-img-stamp-scale"
                                                src={window.cafeteria_path.template_url + '/img/left_corner.svg'}
                                            />
                                        }
                                        {
                                            m.acf.stamp_group_2 === '6' &&
                                            <img
                                                className="menu-img-stamp-right-bottom menu-img-stamp-scale"
                                                src={window.cafeteria_path.template_url + '/img/front_corner.svg'}
                                            />
                                        }
                                        {
                                            m.acf.stamp_group_2 === '7' &&
                                            <img
                                                className="menu-img-stamp-right-bottom menu-img-stamp-scale"
                                                src={window.cafeteria_path.template_url + '/img/right_corner.svg'}
                                            />
                                        }
                                        {
                                            m.acf.stamp_group_2 === '3' &&
                                            <React.Fragment>
                                                <div className="menu-img-sold-out"></div>
                                                <img
                                                    className="menu-img-stamp-right-bottom menu-img-stamp-scale"
                                                    src={window.cafeteria_path.template_url + '/img/sold_out.svg'}
                                                />
                                            </React.Fragment>
                                        }
                                    </React.Fragment>
                                }
                                {
                                    m.acf.corner_number !== '' &&
                                    <div
                                        className={`menu-img-corner ${this.cssCornerLabel(m.acf.provide_date, m.acf.time_section, m.acf.corner_number)}`}
                                    >
                                        {m.acf.corner_label !== '' ? m.acf.corner_label : m.acf.corner_number}
                                    </div>
                                }
                            </div>
                        }
                        <div className="menu-body">
                            <div className="menu-title">
                                <div className="menu-name">{m.acf.menu_name}</div>
                                <div className="menu-price">
                                    {
                                        this.state.cafeteria_base.cafeteria_tax === 'in_tax_price' &&
                                        <span>税込</span>
                                    }
                                    {Intl.NumberFormat('ja-JP').format(price)}
                                    {
                                        this.state.cafeteria_base.cafeteria_tax === 'in_tax_price' &&
                                        <span>円</span>
                                    }
                                    {
                                        this.state.cafeteria_base.cafeteria_tax !== 'in_tax_price' &&
                                        <span>円＋税</span>
                                    }
                                </div>
                            </div>
                            <div className="menu-overview">
                                {this.convertMultiLines(m.acf.overview)}
                            </div>
                        </div>
                        <div className="menu-footer">
                            <div className="menu-footer-cell left">
                                <button
                                    className="menu-detail-btn"
                                    onClick={() => this.setState({selected_acf: m.acf, selected_img_url: m.img_urls.large, is_open_menu_detail: true})}
                                >
                                    <FontAwesomeIcon icon={faWindowRestore} />&nbsp;詳細
                                </button>
                            </div>
                            <div className="menu-footer-cell right">
                                <button
                                    className="menu-like-btn"
                                    onClick={() => this.handleLikeButton(m.acf.mcd, m.like)}
                                >
                                    <svg
                                        className="like-svg"
                                        viewBox="0 0 36 36"
                                    >
                                        <circle className={`cls-1 ${m.like ? 'like' : ''}`} cx={18} cy={18} r={17.5} />
                                        <path className={`cls-2 ${m.like ? 'like' : ''}`} d="M27.33,27.33c-5,5.19-13.71,5.26-18.81.14-5.32-5.04-5.5-13.99-.21-19.15C16.86-.11,31.33,6.06,31.29,18c-.02,3.48-1.48,6.91-3.95,9.33,3.7-3.66,4.82-9.57,2.74-14.33-1.95-4.75-6.94-8-12.07-7.83-6.85.02-12.81,5.98-12.82,12.83-.13,11.68,13.85,17.43,22.16,9.33h0Z" />
                                        <path className="cls-3" d="M9.14,9.14c4.75-4.93,13.02-5,17.86-.14,5.06,4.79,5.24,13.29.21,18.2-8.11,8.01-21.87,2.14-21.82-9.2.02-3.31,1.41-6.56,3.76-8.86-3.52,3.48-4.57,9.09-2.59,13.61,1.86,4.51,6.59,7.58,11.45,7.41,6.49-.03,12.13-5.67,12.15-12.16.13-11.08-13.14-16.54-21.02-8.86h0Z" />
                                        <g className={`cls-4 ${m.like ? 'like' : ''}`}>
                                            <path d="M15.91,15.91v-7.06c0-1,1.04-1.66,1.95-1.24l2.54,1.19c.75.35,1.22,1.1,1.22,1.93v5.18h2.67c1.22,0,2.13,1.14,1.86,2.33l-1.68,6.55c-.23,1.01-1.13,1.73-2.17,1.73h-7.58c-.24,0-.43-.19-.43-.43v-9.76c0-.24.19-.43.43-.43h1.19Z" />
                                            <rect x={9.8} y={15.91} width={3.04} height={10.61} rx={0.48} ry={0.48} />
                                        </g>
                                        <g className={`cls-5 ${m.like ? 'like' : ''}`}>
                                            <path d="M15.91,15.91v-7.06c0-1,1.04-1.66,1.95-1.24l2.54,1.19c.75.35,1.22,1.1,1.22,1.93v5.18h2.67c1.22,0,2.13,1.14,1.86,2.33l-1.68,6.55c-.23,1.01-1.13,1.73-2.17,1.73h-7.58c-.24,0-.43-.19-.43-.43v-9.76c0-.24.19-.43.43-.43h1.19Z" />
                                            <rect x={9.8} y={15.91} width={3.04} height={10.61} rx={0.48} ry={0.48} />
                                        </g>
                                    </svg>
                                </button>
                                <span className="menu-count-like">
                                    {m.count_like && m.count_like != 0 ? m.count_like : 'いいね'}
                                </span>
                            </div>
                        </div>
                    </InView>
                );
            }    
        }

        // 今週来週メニューの場合、日付スライダー一覧を作成
        const weeks = [];
        let slider_num = 0;
        if (!this.state.is_todays_or_weeks) {
            const today_date = dateFns.startOfDay(new Date());
            const pdate = dateFns.parse(this.state.provide_date, 'yyyyMMdd', today_date);
            let start_date = dateFns.subWeeks(today_date, 1);
            let end_date = dateFns.nextSaturday(today_date);
            if (dateFns.getDay(today_date) !== dateFns.getDay(end_date)) {
                end_date = dateFns.nextSaturday(end_date);
            }
            let i = 0;
            while (dateFns.isBefore(start_date, end_date) || dateFns.isEqual(start_date, end_date)) {
                if (
                    (dateFns.isSaturday(start_date) && !this.state.cafeteria_base.cafeteria_open_saturday) ||
                    (dateFns.isSunday(start_date) && !this.state.cafeteria_base.cafeteria_open_sunday)
                ) {
                    // 土日営業しない場合、土日の日付ボタンをスキップする
                    // もし、スキップした日付が当日だった場合、スライダー位置を設定しておく
                    if (dateFns.isEqual(start_date, today_date)) {
                        slider_num = i;
                    }
                } else {
                    let btn_class = dateFns.isEqual(start_date, today_date) ? 'today-btn' : (dateFns.isAfter(start_date, today_date) ? 'after-btn' : '');
                    let btn_active = this.state.provide_date !== '' && dateFns.isEqual(start_date, pdate) ? ' active' : '';
                    const target_date = dateFns.format(start_date, 'yyyyMMdd');
                    weeks.push(
                        <SwiperSlide className="weeks-day-slide">
                            <div className="weeks-day-btn">
                                <button
                                    className={btn_class + btn_active}
                                    onClick={() => this.onClickDateButton(target_date)}
                                >
                                    {dateFns.format(start_date, 'M/d')}<br/>
                                    {dateFns.format(start_date, '(E)', {locale: ja})}
                                </button>
                            </div>
                        </SwiperSlide>
                    );
                    if (btn_class === 'today-btn') {
                        slider_num = i;
                    }
                    i++;
                }
                start_date = dateFns.addDays(start_date, 1);
            }
        }

        // イベント／お知らせスライダー一覧を作成
        const events = [];
        const len = this.state.event_news.length;
        for (let i = 0; i < len; i++) {
            const modified_date = this.state.event_news[i].modified.replaceAll(/[-T:]/g, '');
            events.push(
                <SwiperSlide>
                    <div
                        className="event-slide"
                        onClick={() => this.setState({is_open_event_image: true, selected_event_img_url: this.state.event_news[i].acf.event_img.url})}
                    >
                        <img src={this.state.event_news[i].acf.event_img.url + '?ver=' + modified_date} />
                    </div>
                </SwiperSlide>
            );
        }

        // リンク一覧を作成
        const links = [];
        if (this.state.site_link.length > 0) {
            for (const li of this.state.site_link) {
                const modified_date = li.modified.replaceAll(/[-T:]/g, '');
                links.push(
                    <InView
                        className="link-content transition-1s move-y-50 opacity-0"
                        as="div"
                        rootMargin="-50px"
                        triggerOnce={true}
                        onChange={(inView, entry) => {if(inView) {entry.target.className = "link-content transition-1s move-y-0 opacity-1"}}}
                    >
                        <a href={li.acf.link_url}>
                            <img src={li.acf.link_img.url + '?ver=' + modified_date} />
                        </a>
                    </InView>
                );
            }
        }

        return (
            <React.Fragment>
                <div className="main-contents">
                    <div className="navi-bar">
                        <div className={`navi-group ${this.state.is_open_navi_menu ? 'menu-open' : ''}`}>
                            {/** トップバー、固定 */}
                            <button
                                className="navi-button"
                                onClick={() => this.onClickNaviMenu()}
                            >
                                <img src={window.cafeteria_path.template_url + '/img/navi_button.svg'} />
                            </button>
                            {/** メニューボタン */}
                            <div className="navi-menu">
                                <button
                                    onClick={() => this.onClickNaviMenuButton('menu-target', true)}
                                >
                                    本日のメニュー
                                </button>
                                <button
                                    onClick={() => this.onClickNaviMenuButton('menu-target', false)}
                                >
                                    今週／来週のメニュー
                                </button>
                                <Link to="/nutrition-calc/" className="navi-button">
                                    栄養計算
                                </Link>
                                <Link to="/calc-history/" className="navi-button">
                                    栄養計算履歴
                                </Link>
                                <button
                                    onClick={() => this.onClickNaviMenuButton('event-target')}
                                >
                                    イベント／お知らせ
                                </button>
                                <button
                                    onClick={() => this.onClickNaviMenuButton('link-target')}
                                >
                                    リンク
                                </button>
                                <Link to="/site-policy/" className="navi-button">
                                    サイトポリシー
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="top-banner-area mb-1rem">
                        {/** トップバナー */}
                        <img src={window.cafeteria_base.cafeteria_logo} />
                    </div>
                    <div id="menu-target" className="tab-area">
                        {/** 本日、今週来週切替タブ */}
                        <div className="tab-cell">
                            <button
                                className={`tab-button ${this.state.is_todays_or_weeks ? 'active' : ''}`}
                                onClick={() => this.changeMenuTab(true)}
                            >
                                本日
                            </button>
                        </div>
                        <div className="tab-cell">
                            <button
                                className={`tab-button ${this.state.is_todays_or_weeks ? '' : 'active'}`}
                                onClick={() => this.changeMenuTab(false)}
                            >
                                今週来週
                            </button>
                        </div>
                    </div>
                    <div className="menu-area">
                        {/** メニューエリア */}
                        {
                            !this.state.is_todays_or_weeks &&
                            <InView
                                className="weeks-day-area transition-1s opacity-0"
                                as="div"
                                triggerOnce={true}
                                onChange={(inView, entry) => {if(inView) {entry.target.className = "weeks-day-area transition-1s opacity-1"}}}
                            >
                                <Swiper
                                    id="weeks-day"
                                    modules={[FreeMode, Navigation]}
                                    slidesPerView="auto"
                                    centeredSlides={true}
                                    spaceBetween={10}
                                    initialSlide={slider_num}
                                    navigation={{
                                        enabled: true,
                                    }}
                                    freeMode={{
                                        enabled: true,
                                    }}
                                >
                                    {weeks}
                                </Swiper>
                            </InView>
                        }
                        {menu}
                        {
                            !this.state.is_menu_loading &&
                            menu.length > 0 &&
                            <InView
                                className="menu-next-area transition-1s opacity-0"
                                as="div"
                                triggerOnce={true}
                                onChange={(inView, entry) => {if(inView) {entry.target.className = "menu-next-area transition-1s opacity-1"}}}
                            >
                                <button
                                    className="menu-next-btn"
                                    onClick={() => this.onClickAddLoadingButton()}
                                    disabled={this.state.time_section === '' || this.state.time_section === '9'}
                                >
                                    <FontAwesomeIcon icon={faSquarePlus} />&nbsp;{(this.state.time_section === '' || this.state.time_section === '9') ? 'ここまで' : '次へ'}
                                </button>
                            </InView>
                        }
                        {
                            this.state.is_menu_loading &&
                            <Loading />
                        }
                        {
                            menu.length === 0 &&
                            this.state.provide_date !== '' &&
                            this.state.time_section === '' &&
                            !this.state.is_menu_loading &&
                            <InView
                                className="menu-not-found transition-1s opacity-0"
                                as="div"
                                triggerOnce={true}
                                onChange={(inView, entry) => {if(inView) {entry.target.className = "menu-not-found transition-1s opacity-1"}}}
                            >
                                <img src={window.cafeteria_path.template_url + '/img/not_found.svg'}/>
                            </InView>
                        }
                        {
                            menu.length === 0 &&
                            this.state.time_section === '9' &&
                            !this.state.is_menu_loading &&
                            <InView
                                className="menu-not-found transition-1s opacity-0"
                                as="div"
                                triggerOnce={true}
                                onChange={(inView, entry) => {if(inView) {entry.target.className = "menu-not-found transition-1s opacity-1"}}}
                            >
                                <img src={window.cafeteria_path.template_url + '/img/next_not_found.svg'}/>
                            </InView>
                        }
                        {
                            menu.length === 0 &&
                            this.state.provide_date === '' &&
                            this.state.time_section === '' &&
                            !this.state.is_menu_loading &&
                            <InView
                                className="weeks-init transition-1s opacity-0"
                                as="div"
                                triggerOnce={true}
                                onChange={(inView, entry) => {if(inView) {entry.target.className = "weeks-init transition-1s opacity-1"}}}
                            >
                                <FontAwesomeIcon icon={faHandPointer} className="hand-pointer-action" />&nbsp;日付を選択してください
                            </InView>
                        }
                    </div>
                    <div id="calc-target" className="calc-area">
                        <div className="calc-tab-area mb-1rem">
                            <div className="calc-cell ac-end bb-1px-solid lh-2">
                                栄養計算
                            </div>
                        </div>
                        <div className="calc-link-area">
                            <div className="calc-tab-cell">
                                <Link to="/nutrition-calc/" className="calc-button">
                                    <FontAwesomeIcon icon={faCalculator} />&nbsp;栄養計算
                                </Link>
                            </div>
                            <div className="calc-tab-cell">
                                <Link to="/calc-history/" className="calc-history-button">
                                    <FontAwesomeIcon icon={faList} />&nbsp;栄養計算履歴
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div id="event-target" className="event-area">
                        {/** イベントお知らせエリア */}
                        <div className="event-tab-area mb-1rem">
                            <div className="event-cell ac-end bb-1px-solid lh-2">
                                イベント／お知らせ
                            </div>
                        </div>
                        <div className="event-tab-area">
                            {/** 本日、今週来週切替タブ */}
                            <div className="event-tab-cell">
                                <button
                                    className={`tab-button ${this.state.is_todays_or_weeks_or_news === 1 ? 'active' : ''}`}
                                    onClick={() => this.changeEventTab(1)}
                                >
                                    本日
                                </button>
                            </div>
                            <div className="event-tab-cell">
                                <button
                                    className={`tab-button ${this.state.is_todays_or_weeks_or_news === 2 ? 'active' : ''}`}
                                    onClick={() => this.changeEventTab(2)}
                                >
                                    今週来週
                                </button>
                            </div>
                            <div className="event-tab-cell">
                                <button
                                    className={`tab-button ${this.state.is_todays_or_weeks_or_news === 3 ? 'active' : ''}`}
                                    onClick={() => this.changeEventTab(3)}
                                >
                                    お知らせ
                                </button>
                            </div>
                        </div>
                        <div className="event-body">
                            {
                                !this.state.is_event_loading &&
                                events.length > 0 &&
                                <InView
                                    className="event-swiper transition-1s opacity-0"
                                    as="div"
                                    triggerOnce={true}
                                    onChange={(inView, entry) => {if(inView) {entry.target.className = "event-swiper transition-1s opacity-1"}}}
                                >
                                    <Swiper
                                        modules={[Autoplay]}
                                        loop={len > 1 ? true : false}
                                        pagination={false}
                                        navigation={false}
                                        spaceBetween={10}
                                        autoplay={{
                                            delay: 10000,
                                            disableOnInteraction: false,
                                        }}
                                        speed={1000}
                                    >
                                        {events}
                                    </Swiper>
                                </InView>
                            }
                            {
                                !this.state.is_event_loading &&
                                events.length <= 0 &&
                                <InView
                                    className="weeks-init transition-1s opacity-0"
                                    as="div"
                                    triggerOnce={true}
                                    onChange={(inView, entry) => {if(inView) {entry.target.className = "weeks-init transition-1s opacity-1"}}}
                                >
                                    <FontAwesomeIcon icon={faCalendarDays} />&nbsp;
                                    {
                                        this.state.is_todays_or_weeks_or_news === 1 ?
                                        '本日開催のイベントはありません' : (
                                            this.state.is_todays_or_weeks_or_news === 2 ?
                                            '今週来週開催のイベントはありません' :
                                            '現在、お知らせはありません'
                                        )
                                    }
                                </InView>
                            }
                            {
                                this.state.is_event_loading &&
                                <Loading />
                            }
                        </div>
                    </div>
                    <div id="link-target" className="link-area">
                        {/** リンク */}
                        <div className="link-tab-area mb-1rem">
                            <div className="link-cell ac-end bb-1px-solid lh-2">
                                リンク
                            </div>
                        </div>
                        <div className="link-body">
                            {
                                !this.state.is_link_loading &&
                                <React.Fragment>
                                    {links}
                                </React.Fragment>
                            }
                            {
                                this.state.is_link_loading &&
                                <Loading />
                            }
                        </div>
                    </div>
                    <div id="policy-target" className="policy-area">
                        <div className="policy-tab-area mb-1rem">
                            <div className="policy-cell ac-end bb-1px-solid lh-2">
                                サイトポリシーについて
                            </div>
                        </div>
                        <div className="policy-link-area">
                            <div className="policy-tab-cell">
                                <Link to="/site-policy/" className="policy-button">
                                    サイトポリシーを表示
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="footer-area">
                        {/** フッター */}
                        <small>Copyright &copy; Uokuni Food Services Co.,Ltd. All rights reserved.</small>
                    </div>
                </div>
                <div className="site-background"></div>
                {
                    this.state.is_open_menu_detail &&
                    <InView>
                        {
                            ({inView, ref, entry}) => (
                                <React.Fragment>
                                    <div ref={ref} className={`modal-background ${inView ? '' : 'opacity-0'}`}></div>
                                    <div className={`menu-detail-area ${inView ? 'opacity-1' : 'opacity-0'}`}>
                                        <div className="menu-detail-header">
                                            <button
                                                onClick={() => this.setState({is_open_menu_detail: false})}
                                            >
                                                <FontAwesomeIcon icon={faCircleXmark} />
                                            </button>
                                        </div>
                                        <div className="menu-detail-scroll">
                                            <div className="menu-detail-img">
                                                {
                                                    this.state.selected_acf.menu_kind === '1' &&
                                                    <img
                                                        src={this.state.selected_img_url}
                                                        onError={(e) => {e.target.src = window.cafeteria_path.template_url + '/img/no_image.svg'}}
                                                    />
                                                }
                                            </div>
                                            <div className="menu-detail-title">
                                                <div className="menu-detail-name">{this.state.selected_acf.menu_name}</div>
                                                <div className="menu-detail-price">
                                                    {
                                                        this.state.cafeteria_base.cafeteria_tax === 'in_tax_price' &&
                                                        <span>税込</span>
                                                    }
                                                    {Intl.NumberFormat('ja-JP').format(this.state.selected_acf[this.state.cafeteria_base.cafeteria_tax])}
                                                    {
                                                        this.state.cafeteria_base.cafeteria_tax === 'in_tax_price' &&
                                                        <span>円</span>
                                                    }
                                                    {
                                                        this.state.cafeteria_base.cafeteria_tax !== 'in_tax_price' &&
                                                        <span>円＋税</span>
                                                    }
                                                </div>
                                            </div>
                                            <div className="menu-detail-overview">
                                                {this.convertMultiLines(this.state.selected_acf.overview)}
                                            </div>
                                            <div className="menu-detail-overview">
                                                {this.convertMultiLines(this.state.selected_acf.detail)}
                                            </div>
                                            <div className="menu-detail-food-value">
                                                <div className="menu-detail-food-header"><FontAwesomeIcon icon={faCubesStacked} />&nbsp;栄養素情報</div>
                                                <div className="menu-detail-cell header text-left">エネルギー</div>
                                                <div className="menu-detail-cell text-right">
                                                    {Intl.NumberFormat('ja-JP').format(Math.round(this.state.selected_acf.calories))}&nbsp;kcal
                                                </div>
                                                <div className="menu-detail-cell header text-left">たんぱく質</div>
                                                <div className="menu-detail-cell text-right">
                                                    {Intl.NumberFormat('ja-JP').format(Math.round(this.state.selected_acf.protein * 10) / 10)}&nbsp;g
                                                </div>
                                                <div className="menu-detail-cell header text-left">脂質</div>
                                                <div className="menu-detail-cell text-right">
                                                    {Intl.NumberFormat('ja-JP').format(Math.round(this.state.selected_acf.lipid * 10) / 10)}&nbsp;g
                                                </div>
                                                <div className="menu-detail-cell header text-left">炭水化物</div>
                                                <div className="menu-detail-cell text-right">
                                                    {Intl.NumberFormat('ja-JP').format(Math.round(this.state.selected_acf.carbohydrate * 10) / 10)}&nbsp;g
                                                </div>
                                                <div className="menu-detail-cell header text-left">飽和脂肪酸</div>
                                                <div className="menu-detail-cell text-right">
                                                    {Intl.NumberFormat('ja-JP').format(Math.round(this.state.selected_acf.saturated_fatty_acids * 100) / 100)}&nbsp;g
                                                </div>
                                                <div className="menu-detail-cell header text-left">食塩相当量</div>
                                                <div className="menu-detail-cell text-right">
                                                    {Intl.NumberFormat('ja-JP').format(Math.round(this.state.selected_acf.sodium_content * 10) / 10)}&nbsp;g
                                                </div>
                                                <div className="menu-detail-cell header text-left">野菜重量</div>
                                                <div className="menu-detail-cell text-right">
                                                    {Intl.NumberFormat('ja-JP').format(Math.round(this.state.selected_acf.vegetable_weight))}&nbsp;g
                                                </div>
                                            </div>
                                            <div className="menu-detail-food-value">
                                                <div className="menu-detail-food-header"><FontAwesomeIcon icon={faShrimp} />&nbsp;アレルギー情報</div>
                                                <div className="menu-detail-cell header text-left">卵</div>
                                                <div className="menu-detail-cell text-center">
                                                    {this.state.selected_acf.egg === '1' ? '◯' : '－'}
                                                </div>
                                                <div className="menu-detail-cell header text-left">乳類</div>
                                                <div className="menu-detail-cell text-center">
                                                    {this.state.selected_acf.milk === '1' ? '◯' : '－'}
                                                </div>
                                                <div className="menu-detail-cell header text-left">小麦</div>
                                                <div className="menu-detail-cell text-center">
                                                    {this.state.selected_acf.wheat === '1' ? '◯' : '－'}
                                                </div>
                                                <div className="menu-detail-cell header text-left">そば</div>
                                                <div className="menu-detail-cell text-center">
                                                    {this.state.selected_acf.buckwheat === '1' ? '◯' : '－'}
                                                </div>
                                                <div className="menu-detail-cell header text-left">落花生</div>
                                                <div className="menu-detail-cell text-center">
                                                    {this.state.selected_acf.peanut === '1' ? '◯' : '－'}
                                                </div>
                                                <div className="menu-detail-cell header text-left">海老</div>
                                                <div className="menu-detail-cell text-center">
                                                    {this.state.selected_acf.shrimp === '1' ? '◯' : '－'}
                                                </div>
                                                <div className="menu-detail-cell header text-left">カニ</div>
                                                <div className="menu-detail-cell text-center">
                                                    {this.state.selected_acf.crab === '1' ? '◯' : '－'}
                                                </div>
                                                <div className="menu-detail-cell header text-left">牛肉</div>
                                                <div className="menu-detail-cell text-center">
                                                    {this.state.selected_acf.beef === '1' ? '◯' : '－'}
                                                </div>
                                                <div className="menu-detail-cell header text-left">くるみ</div>
                                                <div className="menu-detail-cell text-center">
                                                    {this.state.selected_acf.walnut === '1' ? '◯' : '－'}
                                                </div>
                                                <div className="menu-detail-cell header text-left">大豆</div>
                                                <div className="menu-detail-cell text-center">
                                                    {this.state.selected_acf.soybean === '1' ? '◯' : '－'}
                                                </div>
                                                <div className="menu-detail-cell header text-left">鶏肉</div>
                                                <div className="menu-detail-cell text-center">
                                                    {this.state.selected_acf.chicken === '1' ? '◯' : '－'}
                                                </div>
                                                <div className="menu-detail-cell header text-left">豚肉</div>
                                                <div className="menu-detail-cell text-center">
                                                    {this.state.selected_acf.pork === '1' ? '◯' : '－'}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )
                        }
                    </InView>
                }
                {
                    this.state.is_open_event_image &&
                    <InView>
                        {
                            ({inView, ref, entry}) => (
                                <div ref={ref} className={`event-detail ${inView ? 'opacity-1' : 'opacity-0'}`}>
                                    <TransformWrapper>
                                        <TransformComponent>
                                            <img src={this.state.selected_event_img_url} />
                                        </TransformComponent>
                                    </TransformWrapper>
                                    <button
                                        onClick={() => this.setState({is_open_event_image: false})}
                                    >
                                        <FontAwesomeIcon icon={faCircleXmark} />
                                    </button>
                                </div>
                            )
                        }
                    </InView>
                }
            </React.Fragment>
        );
    }
}

export default withCookies(FrontPage);